module.exports = __webpack_public_path__ + "static/media/envios2.8e58f913.jpg";